import React from "react";
import { Box, Typography } from "@mui/material";

const StepperIcon: React.FC<{ IconComponent: React.ElementType, isLast: boolean }> = ({
  IconComponent,
  isLast
}) => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "& svg": {
          width: { xs: 33, md: 49 },
          height: { xs: 33, md: 49 },
          fill: "inherit",
        }
      }}
    >
      <IconComponent />
      {!isLast ? <Typography component="span" 
        sx={{
          marginLeft: { xs: 2, md: 3 },
          borderLeft: "1px solid",
          flex: "1 1 auto"
        }}
      /> : null}
    </Box>
  );
};

export default StepperIcon;
